import {Card, Spin} from 'antd';
import styles from './index.module.scss';
import {language} from "../../../../../utils";
import {FC, useState} from "react";
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import {useAppDispatch} from "../../../../../hooks";
import {downloadAssigmentAgreement, downloadInvestmentAgreement} from "../../../../../features/myInvestments/actions";
import {useTranslation} from "react-i18next";

interface InvestmentAgreementDownloadProps {
	id: number;
	label: string;
	type?: 'buyer' | 'seller';
}

export const InvestmentAgreementDownload: FC<InvestmentAgreementDownloadProps> = ({
	id,
	label,
	type,
}) => {
	const dispatch = useAppDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const onDownload = async () => {
		setIsLoading(true);
		try {
			if (type) {
				await dispatch(
					downloadAssigmentAgreement({
						investmentId: id,
						type,
						lang: language,
						fileName: `${label}.pdf`,
					}),
				);
			} else {
				await dispatch(downloadInvestmentAgreement({ id, lang: language }));
			}
		} finally {
			setIsLoading(false);
		}
	};
	return (
		<button
			className={styles.download}
			disabled={isLoading}
			onClick={onDownload}
			aria-label="download"
		>
			<span>{label}</span>
			<span>
				{isLoading ? <Spin size="small" /> : <DownloadIcon />}
			</span>
		</button>
	);
};

export const InvestmentDocuments = ({ row, loading, agreements }: any) => {
	const isBuyer = agreements?.buyerAgreement;
	const isSeller = agreements?.sellerAgreement;
	const isTwo = isBuyer && isSeller;
	const { t } = useTranslation();
	return (
		<Card bordered={false} loading={loading} className={styles.card}>
			<div className={styles.heading}>
				{t('investmentDocumentsText')}
			</div>
			<div className={styles.root}>
				<InvestmentAgreementDownload id={row?.investmentId} label={t('investmentAgreementText')} />
				{isBuyer && (
					<InvestmentAgreementDownload
						type="buyer"
						id={row?.investmentId}
						label={t('assigmentAgreementText', { number: isTwo ? '#1' : '' })}
					/>
				)}
				{isSeller && (
					<InvestmentAgreementDownload
						type="seller"
						id={row?.investmentId}
						label={t('assigmentAgreementText', { number: isTwo ? '#2' : '' })}
					/>
				)}
			</div>
		</Card>
	)
}

export default InvestmentDocuments;
